const STEPS = [
  {
    tag: "先收",
    title: "把线索全部拢起来",
    text: "不管说法真假，先把散布在各处、与事件相关的爆料、回应与评论归档。缺一条可能就漏掉关键一环。",
  },
  {
    tag: "再分",
    title: "给信息分级",
    text: "区分「有原始出处的」「多方转载的」「仅凭转述的」三类，标注证据强弱，避免把传闻与实锤混为一谈。",
  },
  {
    tag: "后校",
    title: "去重、对时、排先后",
    text: "删掉重复转发，统一时间口径，把每个节点放回正确的先后顺序。时间一旦对不上，逻辑很容易出问题。",
  },
  {
    tag: "持续",
    title: "随着新消息动态更新",
    text: "事件未尘埃落定前，时间线不意味着‘完结’。每有新的回应或证据，就在对应节点上补一笔。",
  },
];

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
            <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
            03 · 时间线方法论
          </p>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            把散落的信息，按节点排成一条线
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
            所谓“看懂整件事”，很大程度上就是把每个消息放回它的<b className="font-semibold text-foreground-950">时间与出处</b>。
            一条可信的时间线不是靠背一两个日期，而是靠一套可复现的整理流程。
          </p>

          <div className="mt-6 bg-secondary-100 border-l-4 border-secondary-500 rounded-r-md p-4 text-sm text-secondary-900 leading-relaxed">
            <p className="flex items-center gap-2 font-semibold">
              <i className="ri-information-line w-4 h-4 flex items-center justify-center" />
              关于本站时间线
            </p>
            <p className="mt-2">
              本站目前整理的是<b className="font-semibold">梳理方法与通用脉络框架</b>。具体事件各节点的精确日期，
              请以可溯源的一手信源与权威通报为准，不要采信单一二手账号的单方面说法。
            </p>
          </div>

          <div className="mt-6 flex flex-wrap gap-2">
            {["只引用原始出处", "时间优先排序", "注明证据强度", "随事实更新"].map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700"
              >
                <i className="ri-check-line text-primary-500 w-3.5 h-3.5 flex items-center justify-center" />
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="relative timeline-rail pl-12 flex flex-col gap-7">
            {STEPS.map((s, i) => (
              <li key={s.title} className="relative">
                <span className="absolute left-0 top-0 w-9 h-9 -translate-x-[3.25rem] flex items-center justify-center rounded-full bg-accent-500 text-background-50 font-label">
                  {i + 1}
                </span>
                <span className="inline-block px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-xs mb-1">
                  {s.tag}
                </span>
                <h3 className="font-heading font-semibold text-lg text-foreground-950">{s.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{s.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}